import { render, staticRenderFns } from "./PriceListEdit.vue?vue&type=template&id=71d66d07&"
import script from "./PriceListEdit.vue?vue&type=script&lang=js&"
export * from "./PriceListEdit.vue?vue&type=script&lang=js&"
import style0 from "./PriceListEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports